import { useDispatch, useSelector } from 'react-redux';
import {loadCustomTable, updateCustomTable}  from '../actions/customTable';
import { RootState } from '../reducers';

export const useCustomTableState = () => {
  const  customTable  = useSelector((state: RootState) => state.customTable.customTable);
  const  customTableLive  = useSelector((state: RootState) => state.customTable.customTableLive);
  return {customTable, customTableLive};
};

export const useCustomTableDispatch = () => {
  const dispatch = useDispatch();
  return {
        loadCustomTable: (user: string, live?:boolean) => dispatch(loadCustomTable(user, live)),
        updateCustomTable: (customTable:any, user: string, live?: boolean) => dispatch(updateCustomTable(customTable, user, live))
};
};